package top.wcpe.allincore.dsl.compiler.semantic

/**
 * RFC §3.3 内建函数白名单（编译期共享单一定义）。
 *
 * 在解析层（[top.wcpe.allincore.dsl.compiler.parse.ExpressionParser]）与语义层
 * （[ClassBodyChecker] 等）共用，避免两处重复维护导致漂移：
 * - 解析层：未被局部 `var` / screen 级 `fun` 遮蔽时，这些名字的 `name(args)` 调用会被
 *   识别为 [top.wcpe.allincore.dsl.compiler.ast.ExprAst.BuiltinCallExpr]
 * - 语义层：class 内 fun 调用这些名字时不会被 [ClassBodyChecker] 视为越权访问宿主作用域
 *
 * 新增 / 修改内建函数时仅在本处更新即可。
 */
object BuiltinFunctions {

    /** 全部内建函数名，保留插入顺序便于诊断与调试。 */
    val NAMES: Set<String> = linkedSetOf(
        // 输出
        "print", "log",
        // 异步
        "delay",
        // 一元数学
        "sin", "cos", "tan", "abs", "sqrt", "floor", "ceil", "round", "fract",
        // 多元数学
        "min", "max", "clamp", "lerp", "smoothstep", "mod",
        // 颜色构造
        "rgba", "hsva",
        // 颜色函数（与编译期主题块共用语义，运行时由 CallDispatcher 求值）
        "lighten", "darken", "alpha", "mix",
        // M6-f §8.4：字符串格式化
        "format",
        // M6-h Round 2：toast 通知
        "toast",
        // M6-i：程序化触发动画（任意上下文，含 fun / lambda / 事件回调）
        "animate",
        // PAPI pipe 转换函数：失败时运行时返回 null，便于用 Elvis 兜底
        "Number", "Boolean",
        // v4 C.3：几何 hit-test（纯算术，无副作用，与 clamp / lerp 同性质）
        "hitRect", "hitCircle", "hitArc",
    )
}
